import { useEffect, useState } from "react";
import { getLLMApiKeys } from "../TenantSettings/Api/settingsApi";

export const LLM_PROVIDER_KEY_NOT_CONFIGURED_MESSAGE = "Configure LLM key in Tenant setting.";
export const LLM_TASK_ALREADY_IN_PROGRESS_MESSAGE = "Already in progress";

export function useLLMProviderAvailability() {
  const [hasConfiguredLLMProviderKey, setHasConfiguredLLMProviderKey] = useState(false);
  const [isCheckingLLMProviderKey, setIsCheckingLLMProviderKey] = useState(true);

  useEffect(() => {
    let active = true;

    const loadProviderKeys = async () => {
      try {
        const keys = await getLLMApiKeys();
        if (!active) return;
        setHasConfiguredLLMProviderKey(
          Array.isArray(keys) && keys.some((key) => Boolean(key.active && key.hasApiKey))
        );
      } catch {
        if (!active) return;
        setHasConfiguredLLMProviderKey(false);
      } finally {
        if (active) {
          setIsCheckingLLMProviderKey(false);
        }
      }
    };

    loadProviderKeys();

    return () => {
      active = false;
    };
  }, []);

  return {
    hasConfiguredLLMProviderKey,
    isCheckingLLMProviderKey,
  };
}
